import React from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { cardSx, iconWrapperSx, labelSx } from './styles';
import { LucideIcon } from 'lucide-react';

interface PaymentMethodCardProps {
  title: string;
  icon: LucideIcon;
  selected?: boolean;
  onClick?: () => void;
}

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  title,
  icon: Icon,
  selected = false,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      sx={{
        ...cardSx,
        cursor: 'pointer',
        height: '100%', 
        minHeight: '120px', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        ...(selected && {
          outline: '2px solid #6C7CFF',
          outlineOffset: '-2px',
        }),
      }}
    >
      <Stack sx={iconWrapperSx}>
        <Icon size={24} color="#CCD4FF" />
      </Stack>

      <Typography sx={labelSx} align="center">
        {title}
      </Typography>
    </Card>
  );
};

export default PaymentMethodCard;